import _ from 'lodash';
import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import WorkGroupCollection from "@/collections/lab/WorkGroupCollection";

export default class StaffModel extends LabServiceModel {
  modelName() {
    return 'staff';
  }
  icon() {
    return "user"
  }
  defaults() {
    return {
      id: null,
      user: null,
      user_id: null,
      laboratory: null,
      laboratory_id: null,
      first_name: null,
      last_name: null,
      title: null,
      email: null,
      phone_number: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      work_groups: {},
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      first_name: (val) => (this.nullStringMutator(val)),
      last_name: (val) => (this.nullStringMutator(val)),
      title: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      phone_number: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  formatName(last_first = false, stored_vals = false) {
    let components = [];

    if (stored_vals) {
      components = _.compact([this.$.first_name, this.$.last_name]);
    } else {
      components = _.compact([this.first_name, this.last_name]);
    }

    if (last_first) {
      components = components.reverse();
    }

    return _.join(components, (last_first ? ', ' : ' '));
  }
  getWorkGroups() {
    return this.getRelatedCollection((new WorkGroupCollection()), 'work_groups');
  }

}
